import { MakeRequired } from '@shared/typeHelpers'
import { LinkButton, LinkButtonProps } from '@ui-components/actions/LinkButton'
import { ExternalLinkIcon } from '@ui-components/assets/Icons'
import { useIntl } from 'react-intl'

type SelectedLinkButtonProps = Pick<LinkButtonProps, 'href' | 'label' | 'onClick'>

type ExternalLinkButtonProps = MakeRequired<SelectedLinkButtonProps, 'label'>

export const ExternalLinkButton = ({ label, ...rest }: ExternalLinkButtonProps) => {
  const intl = useIntl()
  const ariaLabel = label + ' ' + intl.formatMessage({ id: 'common-opens-in-a-new-tab' })
  return (
    <LinkButton
      aria-label={ariaLabel}
      icon={<ExternalLinkIcon />}
      iconPos="after"
      label={label}
      target="_blank"
      variant="primary"
      {...rest}
    />
  )
}
